import React from 'react';
import { AccordionSummary, Checkbox } from "@material-ui/core";
import { useStyles } from "../pages/styles";
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

export function downloadPDF(pdf, name) {
    const url = `data:@file/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = name;

    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();
}

export function StyledCheckbox(props) {
  const style = useStyles();
  return (
    <Checkbox
      className={style.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(style.icon, style.checkedIcon)} />}
      icon={<span className={style.icon} />}
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      {...props}
    />
  );
}

export const FlippedOrderExpansionPanelSummary = withStyles({
  root: {
      flexDirection: "row-reverse",
  },
})(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
  IconButtonProps: { edge: "start" },
};

export const handleClickCloseRedirect = () => {
  window.localStorage.removeItem("token_app");
  window.localStorage.removeItem("state");
  window.location.assign(`/auth/login/:message`);
}